import { inject, Injectable } from '@angular/core';
import { PermissionsService } from '@/shared/service/Permissions.service';
import { MessageService } from 'primeng/api';
import { HttpService } from '../../../../../Services/http.service';
import { IProgramaPermiso } from '@/interface/general/IProgramaPermiso.interface';
import { BehaviorSubject, Observable } from 'rxjs';
import { IConfiguracionSistema } from '../../interfaces/consulta-externa-pqrs.interface';
import { IResponseApiGeneric } from '@/interface/general/IResponseApi';
import { TypeResponse } from '@/common/enums/general/TypeResponse';

@Injectable({
  providedIn: 'root',
})
export class ConsultasPqrsService {
  httpService = inject(HttpService);
  messageService = inject(MessageService);
  permissonService = inject(PermissionsService);

  // CodProgram
  CodProgram!: string;
  urlGetInitialData = 'PQR/GetInitialDataPQR';
  urlGetPqrsRadicado = 'PQR/ConsultaExternaPqrsByCodRadicado';
  urlGetGenerateCaptchat = 'Captcha/GenerateCaptcha';
  urlPostValidateCaptchat = 'Captcha/ValidateCaptcha';

  // Variables para los permisos
  programasPermisos!: IProgramaPermiso;
  // Opciones multiselect
  TipoDocumentoOptions: any[] = [];
  TipoPqrOptions: any[] = [];
  ListaGeneroOptions: any[] = [];
  ListaEstadoOptions: any[] = [];
  //#region Carga inicial

  dataLoadedSubject = new BehaviorSubject<boolean>(false);
  dataLoaded$ = this.dataLoadedSubject.asObservable();

  getInitialParameters$(): Observable<
    IResponseApiGeneric<IConfiguracionSistema>
  > {
    return this.httpService.Get<IResponseApiGeneric<IConfiguracionSistema>>(
      this.urlGetInitialData
    );
  }

  getPqrsRadicado$(codRadicado: string): Observable<IResponseApiGeneric<any>> {
    return this.httpService.Get<IResponseApiGeneric<any>>(
      `${this.urlGetPqrsRadicado}?CodRadicado=${codRadicado}`
    );
  }
  
  loadInitialData(): void {
    this.getInitialParameters$().subscribe({
      next: (response: IResponseApiGeneric<IConfiguracionSistema>) => {
        console.table(response);
        if (response?.status === TypeResponse.OK && response.data) {
          const data = response.data;

          //#region  Permisos
          if (data.ProgramasPermisosList?.length) {
            this.programasPermisos = data.ProgramasPermisosList[0];
            this.setProgramaPermisos(this.programasPermisos);
          }
          //#endregion
          //#region  Cargar multiselects
          if (data.TipoDocumento?.length) {
            this.TipoDocumentoOptions = data.TipoDocumento.map((p) => ({
              name: p.Descripcion,
              code: p.CodTipoDocumento,
            }));
          }
          if (data.TipoPqr?.length) {
            this.TipoPqrOptions = data.TipoPqr.map((p) => ({
              name: p.Descripcion,
              code: p.CodTipoPqr,
            }));
          }
          if (data.ListaGenero?.length) {
            this.ListaGeneroOptions = data.ListaGenero.map((p) => ({
              name: p.Descripcion,
              code: p.CodGenero,
            }));
          }
          if (data.ListaEstado?.length) {
            this.ListaEstadoOptions = data.ListaEstado.map((p) => ({
              name: p.Descripcion,
              code: p.CodEstado,
            }));
          }

          //#endregion Fechas
          this.dataLoadedSubject.next(true);
        } else {
          console.warn(
            'La respuesta no tiene status OK o sin Carga Inicial:',
            response
          );
          this.messageService.add({
            severity: 'warn',
            summary: 'Advertencia',
            detail: 'Sin Permisos en la carga inicial',
            life: 10000,
          });
        }
      }
    });
  }


  setProgramaPermisos(programasPermisos: IProgramaPermiso) {
    // Aqui asignamos los permisos a la Botonera
    this.permissonService.setActiveProgramAndButtons(
      programasPermisos.CodPrograma,
      ['Grabar']
    );

    this.CodProgram = programasPermisos.CodPrograma;
    this.permissonService.setPermissionsForProgram(programasPermisos);

  }

  getGenerateCaptchat(): Observable<
    IResponseApiGeneric<IConfiguracionSistema>
  > {
    return this.httpService.Get<IResponseApiGeneric<IConfiguracionSistema>>(
      this.urlGetGenerateCaptchat
    );
  }

  postvalidateCaptchat(body: any): Observable<IResponseApiGeneric<any>> {
    return this.httpService.Post<IResponseApiGeneric<any>>(
      body,
      this.urlPostValidateCaptchat,
    );
  }
  //#endregion
}
